import React from "react";
import Form from "react-bootstrap/Form";
import { Button } from "@headlessui/react";
import InputField from "components/fields/InputField";
import { Link } from "react-router-dom";

export function SignInView(props) {
  const onSaveWrapped = (event) => {
    event.preventDefault();
    let data = {
      name: event.target.elements.name.value,
      phone1: event.target.elements.phone1.value,
      email: event.target.elements.email.value,
      password: event.target.elements.password.value,
      password_confirmation: event.target.elements.password_confirmation.value,
    };
    props.onSave(data);
  };
  var mmev = window.mmev;
  var backButtonUrl = false;
  if (mmev && mmev.lasturl && mmev.lasturl != "") {
    backButtonUrl = mmev.lasturl;
  }

  return (
    <>
      <div className="flex flex-col flex-1 justify-center px-6 py-32 min-h-full bg-white sm:py-48 lg:py-56 lg:px-8">
        <div className="flex flex-col items-center sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="font-bold tracking-tight text-center text-gray-900 text-2xl/9">
            Account aanmaken
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <Form className="space-y-4" onSubmit={onSaveWrapped}>
            <InputField
              name="name"
              placeholder=""
              lbl="Weergave naam"
              validation={props.validation}
            />
            <InputField
              placeholder=""
              lbl="Telefoonnummer"
              name="phone1"
              validation={props.validation}
            />
            <InputField
              name="email"
              placeholder=""
              lbl="E-mailadres"
              validation={props.validation}
            />
            <InputField
              type="password"
              placeholder=""
              lbl="Wachtwoord"
              name="password"
              validation={props.validation}
              className="mb-0"
            />
            <InputField
              className=""
              type="password"
              placeholder="Wachtwoord herhalen"
              name="password_confirmation"
            />
            <Button
              className="flex justify-center w-full btn-primary"
              type="submit"
            >
              Account aanmaken
            </Button>
          </Form>
          <p className="flex justify-between my-4 w-full text-center text-gray-500 text-sm/6 align-center">
            Heeft u al een account?{" "}
            <Link
              className="font-semibold text-primary hover:text-primary"
              to="/login"
            >
              Inloggen
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
